import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { ProductComponent } from './product/product.component';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean { return false }
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {}
  shouldAttach(route: ActivatedRouteSnapshot): boolean { return false }
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null { return null }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.component === ProductComponent && curr.component === ProductComponent) {
      return false
    }
    return future.routeConfig === curr.routeConfig
  }
}
